import React from 'react';
import { Box, Container, Typography } from '@mui/material';

const Privacy = () => {
  return (
    <Box sx={{ py: { xs: 8, md: 12 } }}>
      <Container maxWidth="md">
        <Typography variant="h3" component="h1" sx={{ fontWeight: 600, mb: 2 }}>
          Privacy Policy
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
          Last updated: {new Date().getFullYear()}
        </Typography>

        <Typography variant="h5" sx={{ fontWeight: 600, mt: 4, mb: 2 }}>
          1. Information We Collect
        </Typography>
        <Typography variant="body1" paragraph>
          We collect only the information we need to run Rinovo and improve it over time:
        </Typography>
        <Typography variant="body1" component="ul" sx={{ pl: 3, mb: 2 }}>
          <li>Account details you provide, like your email and password.</li>
          <li>Search-related data, such as images you upload, text you enter, and your ZIP code.</li>
          <li>Saved items, boards, and basic usage data about how you use the app.</li>
          <li>
            Technical information your browser sends (like IP address and device type) and data
            stored in cookies or local storage so you can stay signed in and keep your preferences.
          </li>
        </Typography>

        <Typography variant="h5" sx={{ fontWeight: 600, mt: 4, mb: 2 }}>
          2. How We Use Information
        </Typography>
        <Typography variant="body1" paragraph>
          We use this information to:
        </Typography>
        <Typography variant="body1" component="ul" sx={{ pl: 3, mb: 2 }}>
          <li>
            Provide and improve the core features of Rinovo, including search, saved items, and
            account login.
          </li>
          <li>
            Keep your account secure and troubleshoot technical issues.
          </li>
          <li>
            Understand how people use Rinovo so we can make the product better.
          </li>
          <li>
            Communicate with you about important updates or support requests.
          </li>
        </Typography>

        <Typography variant="h5" sx={{ fontWeight: 600, mt: 4, mb: 2 }}>
          3. How We Share Information
        </Typography>
        <Typography variant="body1" paragraph>
          We do not sell your personal information. We share information only in a few cases:
        </Typography>
        <Typography variant="body1" component="ul" sx={{ pl: 3, mb: 2 }}>
          <li>
            With infrastructure and analytics providers that help us host, operate, and improve
            Rinovo.
          </li>
          <li>
            If we are required to do so by law, or when we need to protect our rights or the safety
            of users.
          </li>
          <li>
            When you ask us to share data or otherwise give your consent.
          </li>
        </Typography>

        <Typography variant="h5" sx={{ fontWeight: 600, mt: 4, mb: 2 }}>
          4. Your Choices
        </Typography>
        <Typography variant="body1" paragraph>
          You can:
        </Typography>
        <Typography variant="body1" component="ul" sx={{ pl: 3, mb: 2 }}>
          <li>Update your account details from within the app.</li>
          <li>
            Ask us to delete your account and associated personal information, unless we need to
            keep some of it for legal or security reasons.
          </li>
          <li>Adjust cookie and tracking settings in your browser.</li>
        </Typography>

        <Typography variant="h5" sx={{ fontWeight: 600, mt: 4, mb: 2 }}>
          5. Changes to This Policy
        </Typography>
        <Typography variant="body1" paragraph>
          We may update this Privacy Policy as the product evolves. When we make changes, we will
          update the &quot;Last updated&quot; date at the top of this page. If changes are
          significant, we will take reasonable steps to let you know.
        </Typography>

        <Typography variant="h5" sx={{ fontWeight: 600, mt: 4, mb: 2 }}>
          6. Contact Us
        </Typography>
        <Typography variant="body1" paragraph>
          If you have any questions about this Privacy Policy or our privacy practices, you can
          contact us at:
        </Typography>
        <Typography variant="body1" paragraph>
          Email: rinovoco@gmail.com
        </Typography>
      </Container>
    </Box>
  );
};

export default Privacy;



